// extracted by mini-css-extract-plugin
export default {"affiliates-width-wrap":"g_ixwZivY4yOjGbgVdGO","affiliatesWidthWrap":"g_ixwZivY4yOjGbgVdGO","divider":"McpQfCeLM2f1sG0gdJRl"};